import React from 'react';
import { Route } from 'react-router-dom';
import JobTitles from '../pages/jobTitles/JobTitles';
import JobTitlesArchive from '../pages/jobTitles/JobTitlesArchive';
import CreateJobTitle from '../pages/jobTitles/CreateJobTitle';
import EditJobTitle from '../pages/jobTitles/EditJobTitle';
import PermissionGuard from '../components/global/PermissionGuard';

const jobTitlesRoutes = (
    <>
        <Route path="/job-titles" element={<PermissionGuard permission="job_titles_list"><JobTitles /></PermissionGuard>} />
        <Route path="/job-titles/archive" element={<PermissionGuard permission="job_titles_archive_list"><JobTitlesArchive /></PermissionGuard>} />
        <Route path="/job-titles/create" element={<PermissionGuard permission="job_titles_create"><CreateJobTitle /></PermissionGuard>} />
        <Route path="/job-titles/:id/edit" element={<PermissionGuard permission="job_titles_edit"><EditJobTitle /></PermissionGuard>} />
    </>
);

export default jobTitlesRoutes;
